import classNames from 'classnames'
import {FileUploadIcon, HelpIcon, TrashIcon} from '../../../icons'
import InputInfo from '../../../components/core/inputInfo'
import {useState} from 'react'
import {colors} from '../../../utils/colors'
import Error from '../../../components/core/error'
import {statuspageAdvancedSchema} from '../../../utils/validation'
import * as Yup from 'yup'
import {useSelector} from 'react-redux'
const AdvancedFormImage = ({
    isDisabled,
    names,
    currentSrc,
    setCurrentSrc,
    text,
    imageRef,
    active,
    setActive,
    getImage,
    getSignedUrl,
    setFieldValue
}) => {
    const [errors, setErrors] = useState({})
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const DEFAULT_IMAGE_TYPE = 'logo'

    const imageValidationSchema = Yup.object().shape({
        logo: statuspageAdvancedSchema.fields.logo,
        favicon: statuspageAdvancedSchema.fields.favicon
    })

    const handleFileChange = async(e) => {
        const fieldName = names.image === DEFAULT_IMAGE_TYPE ? 'logo' : 'favicon'
        const files = e.target.files

        if (!files || !files.length) {
            setErrors({})
            return
        }

        const file = files[0]

        try {
            await imageValidationSchema.validate({
                [fieldName]: file
            })
            setErrors({})
            await getSignedUrl(e, setFieldValue)
            getImage()
        } catch (validationError) {
            if (!validationError.errors) {
                setErrors({default: 'File cannot be uploaded. Please try later.'})
                return
            }
            setErrors({[fieldName]: validationError?.errors[0]})
        }
    }

    return (
        <div className="w-100 form-element">
            <input
                key={currentSrc}
                disabled={isDisabled}
                type="file"
                name={names.image}
                error={names.image === DEFAULT_IMAGE_TYPE ? errors.logo : errors.favicon}
                id={names.image}
                accept={names.image === DEFAULT_IMAGE_TYPE ? '.png,.jpg,.jpeg,.webp' : '.ico,.png'}
                onChange={(e) => handleFileChange(e)}
            />
            <div
                className={classNames({
                    'file-upload': true,
                    dark: isDarkMode,
                    error: errors[names.image] || errors.default,
                    disable: isDisabled
                })}
            >
                <div
                    className={classNames({
                        images: currentSrc
                    })}
                >
                    {currentSrc ? (
                        <img
                            className="content-img"
                            src={currentSrc}
                            alt={`${names.image}`}
                        />
                    ) : (
                        <FileUploadIcon />
                    )}
                    {currentSrc && (
                        <span
                            className="remover"
                            onClick={() => {
                                setCurrentSrc(null)
                            }}
                        >
                            <TrashIcon stroke={colors.colorWhite} />
                        </span>
                    )}
                </div>
                <label htmlFor={`${names.image}`} className="image-label">
                    <span
                        className="placeholder"
                        dangerouslySetInnerHTML={{
                            __html:
                names.image === DEFAULT_IMAGE_TYPE
                    ? text.logo_requirements
                    : text.favicon_requirements
                        }}
                    />
                    <span className="upload">
                        {names.image === DEFAULT_IMAGE_TYPE ? text.upload_logo : text.upload_favicon}
                    </span>
                </label>
                <div
                    ref={imageRef}
                    className={`help ${active === names.image ? 'active' : ''}`}
                    onClick={() => setActive(active === names.image ? '' : names.image)}
                >
                    <span>
                        <HelpIcon />
                    </span>
                    <InputInfo
                        text={names.image === DEFAULT_IMAGE_TYPE ? text.logo_info : text.favicon_info}
                    />
                </div>
            </div>
            {errors[names.image] && <Error error={errors[names.image]} />}
            {errors.default && <Error error={errors.default} />}
        </div>
    )
}
export default AdvancedFormImage
